import React, { useEffect, useState } from "react";

import Dashboard from "./Dashboard";
import DocumentsValidated from "./DocumentsValidated";
import DocumentsInProgress from "./DocumentsInProgress";
import Preferences from "./Preferences";
import { useParams } from "react-router-dom"
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Button, Form } from 'react-bootstrap';

import { Modal, InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import { data } from "jquery";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import DocumentModal from "./DocumentModal";
import MinimizableContainer from "./MinimizableContainer";
import BootstrapTable from "react-bootstrap-table-next";
import ResearchKeyDropdown from "./ResearchKeyDropdown";
import { showToastAction } from "../../../redux/toastSlice";


let Data =
{
  name: "Template 1",
  created: "Admin",
  category: "Template",
  price: "70.00",
  type: "website",
  email: "test@gmail.com",
  date: "2022-03-11"
}

const Form2 = (props) => {
  const {
    show,
    handleClose,
    DocData,
    setDocData,
    activeSceen,
    setActiveScreen,
    addQrCode
  } = props;

  const containerStyle = {
    border: "2px solid gray",
    maxHeight: "auto",
    // flex: 1,
    height: "auto",
    overflowY: `hidden`,
    padding: "0",
    borderRadius: "5px",
    margin: "0px 7px",
  };

  const bootsrapTableStyle = {
    overflowX: "auto",
    maxHeight: "500px",
    maxWidth: "auto",
    overflowY: "auto",
  }
  const [minimized, setMinimized] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const selectedProject = useSelector(state => state.selectedProject);
  const preferences = useSelector(state => state.preferences);
  const preferencesArray = Object.entries(preferences)
  const filteredPreferences = preferencesArray.filter((el) => el[1] === true);
  const [documentData, setDocumentData] = useState([])
  const dispatch = useDispatch()
  useEffect(() => {
    if (activeSceen === 1) {
      axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/Documents/validated`).then(res => {
        setDocumentData(res?.data?.data)
      })
    }
  }, [activeSceen])

  function encode(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {
      chr1 = input[i++];
      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index 
      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
        keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
  }
  useEffect(() => {
    if (show !== '') {
      // axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/recycle/${window.location.pathname.split("/")[3]}`, {
      axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/recycle/${show}`, {
        headers: {
          // 'Accept': 'application/pdf',
        },
        responseType: 'arraybuffer',
      }).then(res => {
        // console.log("res", res);
        //var bytes = new Uint8Array(res.data);


        // console.log("srcValue",'data:image/png;base64,'+encode(bytes));

        //setDocData('data:image/png;base64,' + encode(bytes))
        const base64 = btoa(
          new Uint8Array(res.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            '',
          ),
        );
        setDocData(`data:application/pdf;base64,${base64}`);
      });
    }
  }, [show])

  const [selectedDoc, setSelectedDoc] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setformData] = useState({})
  // console.log("🚀 ~ file: RecycleDocs2.js ~ line 56 ~ Form1 ~ formData", formData)
  const [data, setdata] = useState(Data)

  const history = useHistory()
  const onChange = (e) => {
    const { name, value } = e.target
    setformData({
      ...formData,
      [name]: value,
    });
  }

  const handleChangeScreen = () => {
    if (activeSceen === 0) {
      setActiveScreen(1)
    } else if (activeSceen === 1) {
      validate(selectedDoc)
    }
  }

  const validate = async (ids) => {
    try {
      if (selectedDoc.length !== 0) {
        await axios.post(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/document/recycle`, { "selected_ids": ids, "add_qr_code": addQrCode }).then(res => {
          // console.log('res...........edrfgedgf.........', res);
          history.push(`/form/${window.location.pathname.split("/")[2]}/documents`)
          handleClose('')
        })
      } else dispatch(showToastAction({ message: "Please select any documents", showToast: true }))

    }
    catch (err) {
      dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
  }

  // Retirer la colonne "TOUT SELECTIONNER" de la liste
  const validPreferences = filteredPreferences.filter(([key]) => key !== 'TOUT SELECTIONNER');

  const documentsColumns = [
    ...validPreferences.map((([key]) => {
      return {
        dataField: key,
        text: key,
        formatter: (data) => formatterColumn(data)
      }
    })),
  ];

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedDoc,
    onSelect: (row, select) => handleOnSelect(row, select),
    onSelectAll: (select, rows) => handleOnSelectAll(select, rows),
    style: { backgroundColor: '#75dfff40' }
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) setSelectedDoc([...selectedDoc, row._id])
    else setSelectedDoc(selectedDoc.filter(x => x !== row._id))
  }

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r._id);
    if (isSelect) setSelectedDoc(ids)
    else setSelectedDoc([])
  }
  // console.log('selected', selectedDoc);
  const formatterColumn = (data) => {
    return data ? <SmartText text={data} /> : '-'
  }

  const SmartText = ({ text, length = 20 }) => {
    const [showLess, setShowLess] = React.useState(true);

    if (text.length < length) {
      return <div>{text}</div>;
    }

    return (
      <div>
        {showLess ? text.slice(0, length) : text}
        {showLess ? <a className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
        >....</a> : <a className="read-or-hide" onMouseOver={() => setShowLess(true)}
        >...less</a>}
      </div>
    );
  };

  const handleCloseDocument = () => setShowModal(false);



  return (<>
    <Modal isOpen={show !== ''} toggle={() => handleClose('')} size={activeSceen === 0 ? "lg" : 'xl'}>
      {/* <ModalHeader toggle={() => handleClose('')}>
        {activeSceen === 0 ? 'Recycling Template' : 'Documents'}
      </ModalHeader> */}
      <ModalBody>
        {/*activeSceen === 0 && <img className="doc-image" style={{ border: '0' }} src={DocData} />*/}
        {activeSceen === 0 && <iframe
          className="doc-image"
          style={{ width: '100%', height: '1000px' }}
          src={DocData}
        >
        </iframe>
        }
        {/* <div className="h-full flex flex-col"> */}
        {/* <h3 className="border-0 m-0 mb-3">Template Name - {(window.location.pathname.split("/")[3]).replaceAll("%20", " ")}</h3> */}
        {/* <div className="row mt-3">

            <div className="col-md-4 m-0 ml-4" style={containerStyle}>
              <div className="my-0">
                <h3 class="data-recyle">Recycling Template</h3>
                <div className="pt-4 pb-4">
                  <img className="doc-image" style={{ border: '0' }} src={DocData} />
                </div>
              </div>
            </div>
          </div> */}
        {/* <div className='dropdown-wrap-outer'>
        <div className='dropdown-wrap btns doc-image-control'>
          <label className='btn-defult' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => history.goBack()}>Back</label>
          <label className='btn-defult' htmlFor="dropdown-box-input" data-toggle="dropdown-box-outer" onClick={() => history.push(`/recycledocs4/${window.location.pathname.split("/")[2]}`)}>Next</label>
        </div>
      </div> */}
        {/* </div> */}

        {activeSceen === 1 &&
          <div>
            <DocumentModal />
            <MinimizableContainer
              // OptionsButton={() => ResearchKeyDropdown({ "documentsStatus": "VALIDATED" })}
              className="form-documents mt-0"
              Title={Title}
              minimized={minimized}
              onMinimizeClick={() => setMinimized(!minimized)}
            >
              <DocumentModal
                selectedDocument={selectedDocument}
                show={showModal}
                handleClose={handleCloseDocument}
                ModalType={''}
                document_status={'VALIDATED'}
              />
              <div className="relative table_box" style={bootsrapTableStyle}>
                {documentData.length !== 0 &&
                  <BootstrapTable
                    keyField='_id'
                    data={documentData}
                    columns={documentsColumns}
                    hover
                    selectRow={selectRow}
                    headerClasses="header-class header-model"
                    noDataIndication={'No data found'}
                  />
                }
              </div>
            </MinimizableContainer>
          </div>
        }
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={() => handleClose('')}>
          Fermer
        </Button>
        <Button color="primary" onClick={handleChangeScreen}>
          {activeSceen === 0 ? 'Suivant' : 'Recycle'}
        </Button>
        {/* {
                    (selectedDocument?.document_status !== "VALIDATED" || userState.user_type == "ADMIN" || userState.user_type == "MASTER") &&
                    <Button color="primary" onClick={handleEdit}>Save</Button>
                }
                <Button color="light" onClick={handleClose}>
                    Close
                </Button> */}
      </ModalFooter>
    </Modal>
  </>
  );
};

function Title() {
  return <h3 style={{ marginBottom: 0, marginLeft: 18 }} className="heading">Sélectionner documents</h3>
}


export default Form2;
